import { render, staticRenderFns } from "./newAddDialog.vue?vue&type=template&id=6edc9236&scoped=true"
import script from "./newAddDialog.vue?vue&type=script&lang=js"
export * from "./newAddDialog.vue?vue&type=script&lang=js"
import style0 from "./newAddDialog.vue?vue&type=style&index=0&id=6edc9236&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc9236",
  null
  
)

export default component.exports